/*
 * Bulk order page (templates/page.bulk-orders.json).
 * One shared state { size, qty } drives the hero calculator, the price table highlight
 * and the order form. Prices come from snippets/bulk-pricing-data.liquid.
 * Form posts multipart to OPPY /api/public/bulk-inquiry (art goes to R2, team gets Slack).
 */
(function () {
  'use strict';

  // Every bulk section includes this script so sections can be reordered or removed; run once.
  if (window.__mpcoBulkPage) return;
  window.__mpcoBulkPage = true;

  var dataEl = document.getElementById('bulk-pricing-data');
  if (!dataEl) return;
  var P;
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }

  // Desktop hero fills one screen: below the real header chrome and above anything fixed to the
  // bottom of the window. Shopify's theme-preview bar (#PBarNextFrameWrapper, ~68px) covers the
  // bottom of the screen for Trevor/staff only; subtract it so the preview matches what buyers see.
  var root = document.documentElement;
  function bottomOverlay() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar) return 0;
    var r = bar.getBoundingClientRect();
    if (!r.height || getComputedStyle(bar).display === 'none' || r.top >= window.innerHeight) return 0;
    return Math.max(0, Math.round(window.innerHeight - r.top));
  }
  function measureHero() {
    var hero = document.querySelector('.bulk-hero');
    if (!hero) return;
    root.style.setProperty('--bulk-hero-top', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px');
    root.style.setProperty('--bulk-hero-bottom', bottomOverlay() + 'px');
  }
  measureHero();
  var heroTimer = null;
  function remeasure() { clearTimeout(heroTimer); heroTimer = setTimeout(measureHero, 100); }
  window.addEventListener('resize', remeasure);
  window.addEventListener('load', measureHero);
  if (window.MutationObserver) {
    // The preview bar is injected late and resizes when hidden; follow it for the first few seconds.
    var watched = null;
    var mo = new MutationObserver(function () {
      var bar = document.getElementById('PBarNextFrameWrapper');
      if (bar && bar !== watched && window.ResizeObserver) {
        watched = bar;
        new ResizeObserver(remeasure).observe(bar);
      }
      remeasure();
    });
    mo.observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['style', 'class'] });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  var SIZES = {};
  P.sizes.forEach(function (s) { SIZES[s.key] = s; });

  var state = { size: 'large', qty: 25 };
  try {
    var qs = new URLSearchParams(window.location.search);
    if (SIZES[qs.get('size')]) state.size = qs.get('size');
    var q0 = parseInt(qs.get('qty'), 10);
    if (q0 >= 1 && q0 <= 100000) state.qty = q0;
  } catch (e) { /* old browser: keep defaults */ }

  function track(event, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(event, props || {}); } catch (e) {}
  }

  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function moneyShort(n) {
    return n % 1 === 0 ? '$' + n.toLocaleString('en-US') : money(n);
  }

  function tier(qty) {
    var idx = -1;
    for (var i = 0; i < P.breaks.length; i++) if (qty >= P.breaks[i]) idx = i;
    return idx;
  }

  /** Same rules as OPPY bulkQuote(): null under the minimum. */
  function quote(sizeKey, qty) {
    var s = SIZES[sizeKey];
    if (!s || !(qty >= P.min)) return null;
    var i = tier(qty);
    var unit = s.prices[i];
    var next = null;
    for (var j = i + 1; j < P.breaks.length; j++) {
      if (s.prices[j] < unit) { next = { qty: P.breaks[j], unit: s.prices[j] }; break; }
    }
    return { unit: unit, total: Math.round(unit * qty * 100) / 100, tier: i, next: next };
  }

  var listeners = [];
  function set(patch, source) {
    var changed = false;
    Object.keys(patch).forEach(function (k) {
      if (state[k] !== patch[k]) { state[k] = patch[k]; changed = true; }
    });
    if (!changed) return;
    listeners.forEach(function (fn) { fn(state, source); });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('size', state.size);
      url.searchParams.set('qty', String(state.qty));
      window.history.replaceState(null, '', url.toString());
    } catch (e) {}
    scheduleCalcEvent(source);
  }
  function on(fn) { listeners.push(fn); fn(state, 'init'); }

  var calcTimer = null;
  function scheduleCalcEvent(source) {
    if (source === 'init') return;
    clearTimeout(calcTimer);
    calcTimer = setTimeout(function () {
      var q = quote(state.size, state.qty);
      track('bulk_calculator_changed', {
        size: state.size, quantity: state.qty, source: source,
        unit_price: q ? q.unit : null, quote_total: q ? q.total : null,
      });
    }, 800);
  }

  function sizeLine(key) {
    var s = SIZES[key];
    return s ? s.label + ' ' + s.w + '×' + s.h + '"' : 'Custom size';
  }

  function clampQty(v) {
    var n = parseInt(String(v).replace(/[^0-9]/g, ''), 10);
    if (!(n >= 1)) return null;
    return Math.min(n, 100000);
  }

  /* ---------- Size lineup (hero) ---------- */
  document.querySelectorAll('[data-lineup-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      track('bulk_lineup_size_clicked', { size: b.getAttribute('data-lineup-size') });
      set({ size: b.getAttribute('data-lineup-size') }, 'lineup');
    });
  });
  on(function (s) {
    document.querySelectorAll('[data-lineup-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lineup-size') === s.size ? 'true' : 'false');
    });
  });

  /* ---------- Calculator ----------
     Quantity rows (Sticker Mule pattern): each row shows its total and the saving vs the
     10-pad price, so the discount is visible without a separate price sheet or nudge. */
  document.querySelectorAll('[data-bulk-calc]').forEach(function (root) {
    var sizeBtns = root.querySelectorAll('[data-size]');
    var list = root.querySelector('[data-qty-list]');
    var unitEl = root.querySelector('[data-unit]');
    var totalEl = root.querySelector('[data-total]');
    var ctas = root.querySelectorAll('[data-bulk-start]');
    var presets = (list.getAttribute('data-presets') || '10,25,50,100,250,500').split(',')
      .map(function (v) { return parseInt(v, 10); })
      .filter(function (n) { return n >= P.min; });
    var customOpen = presets.indexOf(state.qty) < 0;

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () { set({ size: b.getAttribute('data-size') }, 'calculator'); });
    });

    function row(qty, sizeKey) {
      var q = quote(sizeKey, qty);
      var base = SIZES[sizeKey].prices[0];
      var save = q ? Math.round((1 - q.unit / base) * 100) : 0;
      var on = !customOpen && state.qty === qty;
      return '<button type="button" class="bulk-qtyrow" role="radio" aria-checked="' + on + '" data-qty="' + qty + '">' +
        '<span class="bulk-qtyrow__qty">' + qty.toLocaleString('en-US') + '</span>' +
        '<span class="bulk-qtyrow__total">' + moneyShort(q.total) + '</span>' +
        '<span class="bulk-qtyrow__save">' + (save >= 5 ? 'Save ' + save + '%' : '') + '</span>' +
        '</button>';
    }

    function render() {
      var html = presets.map(function (n) { return row(n, state.size); }).join('');
      html += '<div class="bulk-qtyrow bulk-qtyrow--custom" role="radio" aria-checked="' + customOpen + '" data-custom-row>' +
        (customOpen
          ? '<label class="bulk-qtyrow__qty" for="BulkCustomQty">Custom</label>' +
            '<input id="BulkCustomQty" type="number" inputmode="numeric" min="' + P.min + '" max="100000" value="' + state.qty + '" data-custom-qty>' +
            '<span class="bulk-qtyrow__save"></span>'
          : '<button type="button" class="bulk-qtyrow__btn" data-open-custom>Custom quantity</button>') +
        '</div>';
      var focused = document.activeElement && document.activeElement.hasAttribute('data-custom-qty');
      list.innerHTML = html;
      if (focused) { var inp = list.querySelector('[data-custom-qty]'); if (inp) { inp.focus(); var v = inp.value; inp.value = ''; inp.value = v; } }
    }

    list.addEventListener('click', function (e) {
      var r = e.target.closest('[data-qty]');
      if (r) { customOpen = false; set({ qty: parseInt(r.getAttribute('data-qty'), 10) }, 'calculator'); render(); return; }
      if (e.target.closest('[data-open-custom]')) {
        customOpen = true; render();
        var inp = list.querySelector('[data-custom-qty]'); if (inp) { inp.focus(); inp.select(); }
      }
    });
    list.addEventListener('input', function (e) {
      if (!e.target.hasAttribute('data-custom-qty')) return;
      var n = clampQty(e.target.value);
      if (n) set({ qty: n }, 'calculator');
    });
    list.addEventListener('focusout', function (e) {
      if (!e.target.hasAttribute('data-custom-qty')) return;
      var n = Math.max(P.min, clampQty(e.target.value) || P.min);
      e.target.value = n;
      set({ qty: n }, 'calculator');
    });

    ctas.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('bulk-form');
        if (!target) return;
        e.preventDefault();
        var q = quote(state.size, state.qty);
        track('bulk_start_order_clicked', { size: state.size, quantity: state.qty, quote_total: q ? q.total : null });
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        var first = target.querySelector('[data-first-field]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
      });
    });

    on(function (s, source) {
      sizeBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-size') === s.size ? 'true' : 'false');
      });
      if (source !== 'calculator' || !list.querySelector('[data-custom-qty]') || document.activeElement !== list.querySelector('[data-custom-qty]')) {
        if (source === 'form' || source === 'init') customOpen = presets.indexOf(s.qty) < 0;
        render();
      }
      var q = quote(s.size, s.qty);
      root.classList.toggle('is-under-min', !q);
      if (q) {
        totalEl.textContent = moneyShort(q.total);
        unitEl.textContent = money(q.unit) + ' / pad';
      } else {
        totalEl.textContent = '—';
        unitEl.textContent = P.min + '-pad minimum';
      }
    });
  });

  /* ---------- Price table ---------- */
  document.querySelectorAll('[data-bulk-table]').forEach(function (table) {
    table.addEventListener('click', function (e) {
      var cell = e.target.closest('[data-cell-size]');
      if (!cell) return;
      track('bulk_price_table_clicked', { size: cell.getAttribute('data-cell-size'), quantity: parseInt(cell.getAttribute('data-cell-qty'), 10) });
      set({ size: cell.getAttribute('data-cell-size'), qty: parseInt(cell.getAttribute('data-cell-qty'), 10) }, 'table');
    });
    on(function (s) {
      var t = tier(s.qty);
      table.querySelectorAll('[data-cell-size]').forEach(function (c) {
        var active = c.getAttribute('data-cell-size') === s.size && parseInt(c.getAttribute('data-cell-tier'), 10) === t;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      table.querySelectorAll('[data-row-size]').forEach(function (r) {
        r.classList.toggle('is-row', r.getAttribute('data-row-size') === s.size);
      });
      table.querySelectorAll('[data-col-tier]').forEach(function (c) {
        c.classList.toggle('is-col', parseInt(c.getAttribute('data-col-tier'), 10) === t);
      });
    });
  });

  /* ---------- Form ---------- */
  document.querySelectorAll('[data-bulk-form]').forEach(function (form) {
    var endpoint = form.getAttribute('data-endpoint');
    var teamEmail = form.getAttribute('data-team-email');
    var sizeSel = form.querySelector('[name="size"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var customWrap = form.querySelector('[data-custom-size]');
    var wrap = form.closest('[data-bulk-form-wrap]') || form;
    var summary = wrap.querySelector('[data-summary]');
    var drop = form.querySelector('[data-drop]');
    var fileInput = form.querySelector('[data-file-input]');
    var fileList = form.querySelector('[data-file-list]');
    var errorEl = form.querySelector('[data-form-error]');
    var submitBtn = form.querySelector('[type="submit"]');
    var success = wrap.querySelector('[data-success]');
    var MAX_FILES = 5, MAX_BYTES = 250 * 1024 * 1024;
    var ACCEPT = /\.(png|jpe?g|pdf|ai|eps|svg|psd|tiff?|webp)$/i;
    var files = [];
    var started = false;
    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    form.addEventListener('focusin', function () {
      if (started) return;
      started = true;
      track('bulk_form_started', { size: state.size, quantity: state.qty });
    });

    function renderSummary() {
      if (!summary) return;
      var custom = sizeSel.value === 'other';
      if (customWrap) customWrap.hidden = !custom;
      var q = custom ? null : quote(sizeSel.value, state.qty);
      if (custom) {
        summary.innerHTML = '<span class="bulk-summary__main">Custom size × ' + state.qty.toLocaleString('en-US') + '</span><span class="bulk-summary__sub">We’ll price this one by hand.</span>';
      } else if (q) {
        summary.innerHTML = '<span class="bulk-summary__main">' + money(q.total) + '</span><span class="bulk-summary__sub">' +
          sizeLine(sizeSel.value) + ' × ' + state.qty.toLocaleString('en-US') + ' · ' + money(q.unit) + ' each · shipping not included</span>';
      } else {
        summary.innerHTML = '<span class="bulk-summary__main">' + sizeLine(sizeSel.value) + ' × ' + state.qty.toLocaleString('en-US') + '</span><span class="bulk-summary__sub">Under ' + P.min + ' pads? Send it anyway and we’ll see what we can do.</span>';
      }
    }

    sizeSel.addEventListener('change', function () {
      if (SIZES[sizeSel.value]) set({ size: sizeSel.value }, 'form');
      renderSummary();
    });
    qtyInput.addEventListener('input', function () {
      var n = clampQty(qtyInput.value);
      if (n) set({ qty: n }, 'form');
      renderSummary();
    });
    on(function (s) {
      if (sizeSel.value !== 'other') sizeSel.value = s.size;
      if (document.activeElement !== qtyInput) qtyInput.value = s.qty;
      renderSummary();
    });

    /* Art goes straight to R2: ask OPPY for a presigned PUT, upload with progress, keep the key. */
    var uploadUrlEndpoint = endpoint.replace(/\/+$/, '') + '/upload-url';

    function fmtSize(bytes) {
      var mb = bytes / 1048576;
      return mb >= 1 ? mb.toFixed(mb >= 100 ? 0 : 1) + ' MB' : Math.max(1, Math.round(bytes / 1024)) + ' KB';
    }

    function renderFiles() {
      fileList.innerHTML = '';
      files.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'bulk-file is-' + item.status;
        var status =
          item.status === 'uploading' ? 'Uploading ' + item.progress + '%' :
          item.status === 'done' ? 'Uploaded' :
          item.error || 'Upload failed';
        li.innerHTML =
          '<span class="bulk-file__name"></span>' +
          '<span class="bulk-file__size">' + fmtSize(item.file.size) + '</span>' +
          '<span class="bulk-file__actions">' +
            (item.status === 'error' && item.retryable ? '<button type="button" class="bulk-file__btn" data-act="retry">Retry</button>' : '') +
            '<button type="button" class="bulk-file__btn" data-act="remove" aria-label="Remove file">Remove</button>' +
          '</span>' +
          '<span class="bulk-file__status" aria-live="polite"></span>' +
          '<span class="bulk-file__bar" aria-hidden="true"><span style="width:' + (item.status === 'done' ? 100 : item.progress) + '%"></span></span>';
        li.querySelector('.bulk-file__name').textContent = item.file.name;
        li.querySelector('.bulk-file__status').textContent = status;
        li.querySelectorAll('[data-act]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (b.getAttribute('data-act') === 'retry') { startUpload(item); return; }
            if (item.xhr) try { item.xhr.abort(); } catch (e) {}
            files.splice(files.indexOf(item), 1);
            renderFiles();
            settle();
          });
        });
        fileList.appendChild(li);
      });
      drop.classList.toggle('has-files', files.length > 0);
    }

    var waiters = [];
    function pending() { return files.filter(function (f) { return f.status === 'uploading'; }); }
    function settle() {
      if (pending().length) return;
      var w = waiters; waiters = [];
      w.forEach(function (fn) { fn(); });
    }
    function whenUploaded() {
      return new Promise(function (resolve) { waiters.push(resolve); settle(); });
    }

    function fail(item, message, retryable) {
      item.status = 'error';
      item.error = message;
      item.retryable = retryable !== false;
      item.xhr = null;
      track('bulk_art_upload_failed', { bytes: item.file.size, reason: message });
      renderFiles();
      settle();
    }

    function startUpload(item) {
      item.status = 'uploading';
      item.progress = 0;
      item.error = '';
      item.key = null;
      renderFiles();
      var t0 = Date.now();
      fetch(uploadUrlEndpoint, {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: item.file.name, size: item.file.size }),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { status: res.status, json: j }; }); })
        .then(function (r) {
          if (files.indexOf(item) < 0) return;
          if (!r.json.ok) { fail(item, r.json.error || 'Upload failed', r.status >= 500 || r.status === 429); return; }
          var xhr = new XMLHttpRequest();
          item.xhr = xhr;
          xhr.upload.onprogress = function (e) {
            if (!e.lengthComputable) return;
            var pct = Math.min(99, Math.floor((e.loaded / e.total) * 100));
            if (pct !== item.progress) {
              item.progress = pct;
              var li = fileList.children[files.indexOf(item)];
              if (li) {
                li.querySelector('.bulk-file__status').textContent = 'Uploading ' + pct + '%';
                li.querySelector('.bulk-file__bar span').style.width = pct + '%';
              }
              updateSubmitLabel();
            }
          };
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              item.status = 'done';
              item.key = r.json.key;
              item.xhr = null;
              track('bulk_art_uploaded', { bytes: item.file.size, seconds: Math.round((Date.now() - t0) / 1000) });
              renderFiles();
              settle();
            } else {
              fail(item, 'Upload failed');
            }
          };
          xhr.onerror = function () { fail(item, 'Upload failed. Check your connection'); };
          xhr.onabort = function () { item.xhr = null; };
          xhr.open('PUT', r.json.url);
          xhr.setRequestHeader('Content-Type', r.json.contentType);
          xhr.send(item.file);
        })
        .catch(function () { if (files.indexOf(item) >= 0) fail(item, 'Upload failed. Check your connection'); });
    }

    function addFiles(list) {
      var rejected = [];
      Array.prototype.forEach.call(list, function (f) {
        if (!ACCEPT.test(f.name)) { rejected.push(f.name + ' isn’t a file type we can print from'); return; }
        if (f.size > MAX_BYTES) { rejected.push(f.name + ' is over 250 MB. Paste a Dropbox or Google Drive link instead'); return; }
        if (files.length >= MAX_FILES) { rejected.push('You can attach up to ' + MAX_FILES + ' files'); return; }
        var item = { file: f, status: 'uploading', progress: 0, key: null, xhr: null, error: '', retryable: true };
        files.push(item);
        startUpload(item);
      });
      renderFiles();
      showError(rejected.length ? rejected.join('. ') + '.' : '');
      if (list.length) track('bulk_art_attached', { file_count: files.length, rejected: rejected.length });
    }

    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer) addFiles(e.dataTransfer.files); });

    var submitLabel = submitBtn.querySelector('.bulk-btn__label');
    var submitText = submitLabel ? submitLabel.textContent : '';
    var submitting = false;
    function updateSubmitLabel() {
      if (!submitLabel || !submitting) return;
      var up = pending();
      if (!up.length) { submitLabel.textContent = 'Sending'; return; }
      var total = 0, loaded = 0;
      up.forEach(function (f) { total += f.file.size; loaded += f.file.size * (f.progress / 100); });
      submitLabel.textContent = 'Uploading art ' + Math.floor((loaded / total) * 100) + '%';
    }

    function showError(msg, fallback) {
      if (!msg) { errorEl.hidden = true; errorEl.innerHTML = ''; return; }
      errorEl.hidden = false;
      errorEl.textContent = msg;
      if (fallback) {
        var body = [
          'Name: ' + val('name'),
          'Company: ' + val('company'),
          'Size: ' + (sizeSel.value === 'other' ? 'Custom ' + val('custom_size') : sizeLine(sizeSel.value)),
          'Quantity: ' + state.qty,
          'Fabric: ' + ((form.querySelector('[name="fabric"]:checked') || {}).value || ''),
          'Art link: ' + val('art_link'),
          '', val('notes'),
        ].join('\n');
        var p = document.createElement('p');
        p.innerHTML = 'Email us instead at <a href="mailto:' + teamEmail + '?subject=' + encodeURIComponent('Bulk order request') +
          '&body=' + encodeURIComponent(body) + '">' + teamEmail + '</a> and attach your art.';
        errorEl.appendChild(p);
      }
    }

    function setBusy(on) {
      submitting = on;
      submitBtn.disabled = on;
      submitBtn.classList.toggle('is-loading', on);
      if (on) { submitBtn.setAttribute('aria-busy', 'true'); updateSubmitLabel(); }
      else { submitBtn.removeAttribute('aria-busy'); if (submitLabel) submitLabel.textContent = submitText; }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      showError('');
      if (!form.reportValidity()) return;
      setBusy(true);

      whenUploaded().then(function () {
        var failed = files.filter(function (f) { return f.status === 'error'; });
        if (failed.length) {
          setBusy(false);
          showError(failed.length === 1 ? '“' + failed[0].file.name + '” didn’t upload. Retry it or remove it.' : failed.length + ' files didn’t upload. Retry or remove them.');
          return;
        }
        updateSubmitLabel();
        var fd = new FormData(form);
        fd.set('quantity', String(state.qty));
        fd.set('page_url', window.location.href.split('?')[0]);
        var done = files.filter(function (f) { return f.status === 'done' && f.key; });
        fd.set('art_keys', JSON.stringify(done.map(function (f) { return { key: f.key, name: f.file.name }; })));

        var q = sizeSel.value === 'other' ? null : quote(sizeSel.value, state.qty);
        var props = {
          size: sizeSel.value, quantity: state.qty, fabric: fd.get('fabric'),
          file_count: done.length, has_art_link: !!fd.get('art_link'), has_company: !!fd.get('company'),
          quote_total: q ? q.total : null,
        };

        return fetch(endpoint, { method: 'POST', body: fd, mode: 'cors', credentials: 'omit' })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, json: json }; });
          })
          .then(function (r) {
            if (r.status >= 200 && r.status < 300 && r.json.ok) {
              track('bulk_form_submitted', props);
              showSuccess(q);
              return;
            }
            track('bulk_form_failed', Object.assign({ status: r.status }, props));
            if (r.status === 400 || r.status === 413 || r.status === 429) showError(r.json.error || 'Check the form and try again.');
            else showError('Something went wrong on our end.', true);
          })
          .catch(function () {
            track('bulk_form_failed', Object.assign({ status: 0 }, props));
            showError('We couldn’t reach our server.', true);
          })
          .then(function () { setBusy(false); });
      });
    });

    window.addEventListener('beforeunload', function (e) {
      if (!submitting && pending().length) { e.preventDefault(); e.returnValue = ''; }
    });

    function showSuccess(q) {
      if (!success) return;
      var email = val('email');
      success.querySelector('[data-success-email]').textContent = email;
      var qEl = success.querySelector('[data-success-quote]');
      qEl.textContent = q
        ? sizeLine(sizeSel.value) + ' × ' + state.qty.toLocaleString('en-US') + ' · ' + money(q.total) + ' (' + money(q.unit) + ' each)'
        : (sizeSel.value === 'other' ? 'Custom size' : sizeLine(sizeSel.value)) + ' × ' + state.qty.toLocaleString('en-US');
      form.hidden = true;
      success.hidden = false;
      success.setAttribute('tabindex', '-1');
      success.focus();
      success.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
  });
})();
